const SWITCHES = {
    'switch-eu': 'size-eu',
    'switch-us': 'size-us',
    'switch-uk': 'size-uk',
    'switch-cm': 'size-cm'
};

const toggleClasses = (selector, className, add) =>
    document.querySelectorAll(selector).forEach(element => element.classList.toggle(className, add));

const handleSwitchClick = (activeSwitchClass) => {
    const activeSizeClass = SWITCHES[activeSwitchClass];
    Object.entries(SWITCHES).forEach(([switchClass, sizeClass]) => {
        toggleClasses(`.${sizeClass}`, 'active', sizeClass === activeSizeClass);
        toggleClasses(`.${switchClass}`, 'active', switchClass === activeSwitchClass);
    });
};

const SIZE_STORAGE_KEY = 'coproom_size_system';

const initializeSwitches = () => {
    Object.keys(SWITCHES).forEach(switchClass =>
        document.querySelector(`.${switchClass}`).addEventListener('click', () => {
            handleSwitchClick(switchClass);
            localStorage.setItem(SIZE_STORAGE_KEY, switchClass);
        })
    );
    // Restore saved preference
    const saved = localStorage.getItem(SIZE_STORAGE_KEY);
    if (saved && SWITCHES[saved]) {
        handleSwitchClick(saved);
    }
};

// ── Date helpers (working days) ──────────────────────────────────────────────
const _addWorkingDays = (n) => {
    const d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
};
const _fmtDate = (d) => {
    const J = ['dim','lun','mar','mer','jeu','ven','sam'];
    const M = ['jan','fév','mars','avr','mai','juin','juil','août','sep','oct','nov','déc'];
    return J[d.getDay()] + ' ' + d.getDate() + ' ' + M[d.getMonth()];
};
const _deliveryHTML = (days) => 'Reçu avant le <strong>' + _fmtDate(_addWorkingDays(days)) + '</strong>';

// ── Variant finders ──────────────────────────────────────────────────────────

// Finds the TLS 48H variant for a given standard variant <li>
// e.g. "42 EU" → finds sibling with variant-title "42 EU 48H"
const normalizeVariantTitle = (title) => (title || '').toLowerCase().replace(/\s/g, '');
const getBaseVariantTitle = (title) => normalizeVariantTitle(title).replace(/(48h|express.*)$/, '');

const find48HVariant = (selectedVariant) => {
    const title = getBaseVariantTitle(selectedVariant.getAttribute('variant-title'));
    const title48H = title + '48h';
    return Array.from(selectedVariant.parentElement.children).find(item =>
        normalizeVariantTitle(item.getAttribute('variant-title')) === title48H
    );
};

// Finds the retail boutique Express variant for a given standard variant <li>
// e.g. "42 EU" → finds sibling with variant-title "42 EU Express 3-5j"
const findExpressVariant = (selectedVariant) => {
    const title = getBaseVariantTitle(selectedVariant.getAttribute('variant-title'));
    return Array.from(selectedVariant.parentElement.children).find(item => {
        const itemTitle = normalizeVariantTitle(item.getAttribute('variant-title'));
        return itemTitle.includes('express') && getBaseVariantTitle(itemTitle) === title;
    });
};

// Returns the best available fast-delivery variant for a standard variant <li>
// Rule: cheapest available express wins (not fastest — customer always prefers lower price)
const getEffectiveExpress = (item) => {
    const v48h = find48HVariant(item);
    const vExpress = findExpressVariant(item);
    const a48h = v48h?.getAttribute('available') === 'true' ? v48h : null;
    const aExpress = vExpress?.getAttribute('available') === 'true' ? vExpress : null;
    if (!a48h && !aExpress) return null;
    if (a48h && !aExpress) return a48h;
    if (!a48h && aExpress) return aExpress;
    // Both available — return cheapest
    return getNumericPrice(a48h.getAttribute('variant-price')) <= getNumericPrice(aExpress.getAttribute('variant-price'))
        ? a48h : aExpress;
};

const getNumericPrice = (priceString) =>
    parseFloat(priceString.replace(/[€$£]/g, '').replace(/,/g, '')) || 0;

// ── Express badge in size grid ───────────────────────────────────────────────
const initExpressTag = () => {
    const listItems = document.querySelectorAll('#f8pr-ul-check-1 > li');
    listItems.forEach(item => {
        const title = item.getAttribute('variant-title').toLowerCase().replace(/\s/g, '');
        // Skip hidden express/48H variant items — only decorate standard ones
        if (title.includes('48h') || title.includes('express')) return;

        const activeExpress = getEffectiveExpress(item);
        if (activeExpress) {
            const label = item.querySelector('label .express-label');
            const isBoutique = activeExpress.getAttribute('data-express-type') === 'boutique';
            label.textContent = isBoutique ? '3-5j' : '48h';
            label.classList.remove('hidden');
        }
    });
};

// ── Choice container update ──────────────────────────────────────────────────
const updateDeliveryOptions = (item, effectiveExpress) => {
    const express = document.querySelector('.express-choice');
    const standard = document.querySelector('.standard-choice');
    const standardPrice = getNumericPrice(item.getAttribute('variant-price'));
    const expressPrice = effectiveExpress ? getNumericPrice(effectiveExpress.getAttribute('variant-price')) : 0;

    standard.querySelector('.delivery-cost').textContent = item.getAttribute('variant-price');
    express.querySelector('.delivery-cost').textContent = effectiveExpress ? effectiveExpress.getAttribute('variant-price') : '';

    // Update express delivery time based on type
    const isBoutique = effectiveExpress?.getAttribute('data-express-type') === 'boutique';
    const expressTimeEl = express.querySelector('.delivery-time');
    if (expressTimeEl && effectiveExpress) {
        expressTimeEl.innerHTML = _deliveryHTML(isBoutique ? 5 : 2);
    }

    // If express price ≤ standard price AND express is available → hide standard (only show express)
    const isStandardDisabled = expressPrice > 0 && standardPrice >= expressPrice && effectiveExpress !== null;
    const isExpressDisabled = effectiveExpress === null;

    standard.classList.toggle('disabled', isStandardDisabled);
    express.classList.toggle('disabled', isExpressDisabled);

    // Gestion initiale de la classe 'clicked'
    standard.classList.remove('clicked');
    express.classList.remove('clicked');

    if (!isStandardDisabled && !isExpressDisabled) {
        // Both available — pre-select express (it's always cheaper or same price)
        express.classList.add('clicked');
        if (effectiveExpress) {
            effectiveExpress.querySelector('input').checked = true;
        }
    } else {
        if (!isStandardDisabled) {
            standard.classList.add('clicked');
            item.querySelector('input').checked = true;
        }
        if (!isExpressDisabled) {
            express.classList.add('clicked');
            if (effectiveExpress) {
                effectiveExpress.querySelector('input').checked = true;
            }
        }
    }
};

const initDeliveryOptions = () => {
    const checkedItem = document.querySelector('#f8pr-ul-check-1 > li input:checked')?.closest('li');
    if (checkedItem) {
        handleVariantChange(checkedItem);
    }

    const express = document.querySelector('.express-choice');
    const standard = document.querySelector('.standard-choice');

    express.addEventListener('click', () => {
        if (!express.classList.contains('disabled')) {
            express.classList.add('clicked');
            standard.classList.remove('clicked');
            const checkedItem = document.querySelector('#f8pr-ul-check-1 > li.checked');
            if (checkedItem) {
                const effectiveExpress = getEffectiveExpress(checkedItem);
                if (effectiveExpress) {
                    effectiveExpress.querySelector('input').checked = true;
                }
            }
        }
    });

    standard.addEventListener('click', () => {
        if (!standard.classList.contains('disabled')) {
            standard.classList.add('clicked');
            express.classList.remove('clicked');
            const checkedItem = document.querySelector('#f8pr-ul-check-1 > li.checked');
            if (checkedItem) {
                checkedItem.querySelector('input').checked = true;
            }
        }
    });
};

const handleVariantChange = (selectedItem) => {
    const listItems = document.querySelectorAll('#f8pr-ul-check-1 > li');
    listItems.forEach(item => item.classList.toggle('checked', item === selectedItem));

    const effectiveExpress = getEffectiveExpress(selectedItem);
    updateDeliveryOptions(selectedItem, effectiveExpress);
};

const setInit = () => {
    initializeSwitches();
    initExpressTag();
    initDeliveryOptions();
};

document.addEventListener('DOMContentLoaded', () => {
    setInit();

    const listItems = document.querySelectorAll('#f8pr-ul-check-1 > li');
    listItems.forEach(item => {
        const input = item.querySelector('input');
        input.classList.add('listening');
        input.addEventListener('change', () => handleVariantChange(item));
    });
});
